module.exports = __webpack_public_path__ + "img/04A.4408013b.jpg";